// Module
var code = "<oc-menu menu-items=\"menuItems['reports']\" allow-search=\"true\"></oc-menu> <ul class=\"nav\" ng-show=\"app.reports.enabled === false\"> <oc-menu-item nav-state=\"app.reports\" is-default=\"true\" text=\"{{'reports.disabledMessage' | xlat}}\"/> </ul>";
// Exports
module.exports = code;